(function () {
	var escapeId = typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
		? function (id) { return CSS.escape(id); }
		: function (id) { return id.replace(/([^\w-])/g, '\\$1'); };

	function switchToTab(tabLink, tabComponent) {
		if (tabLink.classList.contains('active')) return;
		var contentTabId = tabLink.getAttribute('data-target');
		if (!contentTabId) return;
		var rawId = contentTabId.charAt(0) === '#' ? contentTabId.slice(1) : contentTabId;
		var contentTab = tabComponent.querySelector('#' + escapeId(rawId));
		if (!contentTab) return;
		var activeLink = tabComponent.querySelector('.tab-link.active');
		var activePanel = tabComponent.querySelector('.tab-content.active.show');
		var scrollY = window.scrollY;
		if (activeLink) {
			activeLink.classList.remove('active');
			activeLink.setAttribute('aria-selected', 'false');
		}
		tabLink.classList.add('active');
		tabLink.setAttribute('aria-selected', 'true');
		if (activePanel) {
			activePanel.classList.remove('active', 'show');
			activePanel.style.display = 'none';
		}
		contentTab.classList.add('active');
		contentTab.style.display = 'block';
		setTimeout(function () {
			contentTab.classList.add('show');
			window.scrollTo(0, scrollY);
			var swiperEls = contentTab.querySelectorAll('.swiper');
			for (var i = 0; i < swiperEls.length; i++) {
				var el = swiperEls[i];
				if (el.swiper && typeof el.swiper.update === 'function') {
					el.swiper.update();
				}
			}
		}, 10);
	}

	function handleTabClick(e) {
		if (e.button !== 0) return;
		var tabLink = e.target && e.target.closest ? e.target.closest('.tab-link') : null;
		if (!tabLink) return;
		var tabComponent = tabLink.closest('.tabs-component');
		if (!tabComponent) return;
		e.preventDefault();
		e.stopPropagation();
		switchToTab(tabLink, tabComponent);
	}

	function handleTabKeydown(e) {
		var tabLink = e.target && e.target.closest ? e.target.closest('.tab-link') : null;
		if (!tabLink) return;
		var tabComponent = tabLink.closest('.tabs-component');
		if (!tabComponent) return;
		var tablist = tabComponent.querySelector('[role="tablist"]');
		if (!tablist) return;
		var tabs = tablist.querySelectorAll('.tab-link[role="tab"]');
		var currentIndex = -1;
		for (var i = 0; i < tabs.length; i++) {
			if (tabs[i] === tabLink) { currentIndex = i; break; }
		}
		if (currentIndex < 0) return;
		var nextIndex = currentIndex;
		switch (e.key) {
			case 'ArrowLeft':
			case 'ArrowUp':
				e.preventDefault();
				nextIndex = currentIndex <= 0 ? tabs.length - 1 : currentIndex - 1;
				break;
			case 'ArrowRight':
			case 'ArrowDown':
				e.preventDefault();
				nextIndex = currentIndex >= tabs.length - 1 ? 0 : currentIndex + 1;
				break;
			case 'Home':
				e.preventDefault();
				nextIndex = 0;
				break;
			case 'End':
				e.preventDefault();
				nextIndex = tabs.length - 1;
				break;
			case 'Enter':
			case ' ':
				e.preventDefault();
				switchToTab(tabLink, tabComponent);
				return;
			default:
				return;
		}
		if (nextIndex !== currentIndex) {
			tabs[nextIndex].focus();
			switchToTab(tabs[nextIndex], tabComponent);
		}
	}

	function initTabsComponents() {
		var components = document.querySelectorAll('.tabs-component');
		for (var c = 0; c < components.length; c++) {
			var tabComponent = components[c];
			var panels = tabComponent.querySelectorAll('.tab-content');
			var activeLink = tabComponent.querySelector('.tab-link.active');
			var activeTarget = activeLink && activeLink.getAttribute('data-target');
			var rawId = activeTarget && activeTarget.charAt(0) === '#' ? activeTarget.slice(1) : activeTarget;
			for (var p = 0; p < panels.length; p++) {
				var panel = panels[p];
				var isActive = rawId && panel.id === rawId;
				panel.classList.remove('active', 'show');
				if (isActive) {
					panel.classList.add('active', 'show');
					panel.style.display = '';
				} else {
					panel.style.display = 'none';
				}
			}
		}
	}

	function init() {
		initTabsComponents();
		document.removeEventListener('click', handleTabClick, true);
		document.addEventListener('click', handleTabClick, true);
		document.removeEventListener('keydown', handleTabKeydown, true);
		document.addEventListener('keydown', handleTabKeydown, true);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
